export const initialSupplierPrefixesStore = {
  data: {
    supplierPrefixes: [],
  },
};
